import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface KnowledgebaseItemViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class KnowledgebaseItemViewPage extends Component<KnowledgebaseItemViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.knowledgebase_item.view }}
                pages={{
                    entity: InferenceEntities.knowledgebase_item(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}